<div class="notification-wrapper">
    <app-notification *ngFor="let entry of notifications" [type]="entry.data.type" [message]="entry.data.message"
        (dismiss)="dismissById(entry.id)">
    </app-notification>
</div>
